<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "App",
  components: {},
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import url(https://db.onlinewebfonts.com/c/deb752222f366fbe12e7c9b0012b782c?family=LIBRARY+3+AM);

* {
  scrollbar-color: #7528c2 transparent;
}

*::-webkit-scrollbar {
  width: 7px;
}

*::-webkit-scrollbar-thumb {
  background-color: #7528c2;
  border-radius: 20px;
}
</style>
